// import dev from './dev.json';
import int from './int.json';
import local from './local.json';
import prod from './prod.json';

let config = {};

if (process.env.BUILD_ENV === 'production') {
    config = prod;
} else if (process.env.BUILD_ENV === 'development') {
    config = int;
} else if (process.env.BUILD_ENV === 'integration') {
    config = int;
} else {
    config = local;
}

export default {
    ...config,
};
